import { Link } from "react-router";
import { useAuth } from "@/hooks/use-auth";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export const CredentialsCard = () => {
    const { user } = useAuth();

    let email = "";
    if (user !== null) {
        email = user.email;
    }

    return (
        <Card
            size="lg"
            className="flex max-w-[calc(100dvw-2rem)] flex-col gap-y-6"
        >
            <div className="w-full">
                <h2 className="mb-3 text-xl font-semibold">Login details</h2>
            </div>
            <div className="flex w-full max-w-full flex-col gap-x-3 gap-y-6 md:w-fit md:min-w-md">
                <div className="flex flex-1 flex-row gap-3 gap-x-4 md:gap-x-8">
                    <p className="w-16 shrink-0 text-sm/6 font-medium text-darkgreen-500">
                        Email
                    </p>
                    <div className="flex-auto shrink-1 truncate">
                        <p className="truncate">{email}</p>
                    </div>
                    <div className="flex-1">
                        <Button
                            variant="primary"
                            size="sm"
                            className="ms-auto"
                            asChild
                        >
                            <Link to="email">Change</Link>
                        </Button>
                    </div>
                </div>
                <div className="flex flex-1 flex-row gap-3 gap-x-4 md:gap-x-8">
                    <p className="w-16 shrink-0 text-sm/6 font-medium text-darkgreen-500">
                        Password
                    </p>
                    <div className="flex-auto shrink-1 truncate">
                        <p className="truncate">••••••••</p>
                    </div>
                    <div className="flex-1">
                        <Button
                            variant="primary"
                            size="sm"
                            className="ms-auto"
                            asChild
                        >
                            <Link to="password">Change</Link>
                        </Button>
                    </div>
                </div>
            </div>
        </Card>
    );
};
